export interface IConfigurationValueSelect {
    /**
     * we should use "text" as key to fit for v-model of v-select
     */
    text: string;
    value: string | number;
    disabled?: boolean;
    subText?: string;
}

export class ConfigurationValueSelect {
    /**
     * we should use "text" as key to fit for v-model of v-select
     */
    public text: string;
    public value: string | number;
    public disabled?: boolean;
    public subText?: string;

    constructor();
    // tslint:disable-next-line: unified-signatures
    constructor(obj: IConfigurationValueSelect);
    constructor(obj?: any) {
        this.text = (obj && obj.text) || '';
        this.value = obj && obj.value != null ? obj.value : undefined;

        if (obj) {
            if (obj.name != null) {
                this.text = obj.name;
            }
            if (obj.disabled != null) {
                this.disabled = obj.disabled;
            }
            if (obj.subText != null) {
                this.subText = obj.subText;
            }
        }
    }
}
